import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue";
import DMR from "./components/DMR.vue";
import Ezpay from "./components/Ezpay.vue";
import Instapay from "./components/Instapay.vue";
import AEPS from "./components/AEPS.vue";
import Offers from "./components/Offers.vue";
import Settings from "./components/Settings.vue";
import Account from "./components/Account.vue";
import Loadmoney from "./components/Loadmoney.vue";
import QRcode from "./components/QRcode.vue";
import Last50Recharge from "./report/Last50Recharge.vue";
import SearchRecharge from "./report/SearchRecharge.vue";
import Passbook from "./report/Passbook.vue";
import PassbookStatement from "./report/PassbookStatement.vue";
import PeerToPeerStatement from "./report/PeerToPeerStatement.vue";
import DailyStatement from "./report/DailyStatement.vue";
import Commissions from "./report/Commissions.vue";
import MyCommissions from "./report/MyCommissions.vue";
import PassbookWithDrawal from "./report/PassbookWithDrawal.vue";
import WithdrawaltoBank from "./report/WithdrawaltoBank.vue";
import DTHBooking from "./report/DTHBooking.vue";
import DailyUserReport from "./report/DailyUserReport";
import Complaint from "./report/Complaint";
import Shopping from "./components/Shopping";
import InstantPayout from "./components/InstantPayout";
import AEPSPayout from "./components/AEPSPayout";
import MinksPay from "./components/MinksPay";
import PaytmCallback from "./components/PaytmCallback";
import GetQRCode from "./components/GetQRCode"
Vue.use(Router);

export default new Router({
  //mode: 'history',
  //base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/last50recharge",
      name: "last50recharge",
      component: Last50Recharge,
    },
    {
      path: "/searchrecharge",
      name: "searchrecharge",
      component: SearchRecharge,
    },
    {
      path: "/dmrtransfer",
      name: "dmrtransfer",
      component: DMR,
    },
    {
      path: "/minkspay",
      name: "minkspay",
      component: MinksPay,
    },
    {
      path: "/ezpay",
      name: "ezpay",
      component: Ezpay,
    },
    {
      path: "/instapay",
      name: "instapay",
      component: Instapay,
    },
    {
      path: "/aeps",
      name: "aeps",
      component: AEPS,
    },
    {
      path: "/passbook",
      name: "passbook",
      component: Passbook,
    },
    {
      path: "/passbookstatement",
      name: "passbookstatement",
      component: PassbookStatement,
    },
    {
      path: "/peertopeerstatement",
      name: "peertopeerstatement",
      component: PeerToPeerStatement,
    },
    {
      path: "/passbookwithdrawal",
      name: "passbookwithdrawal",
      component: PassbookWithDrawal,
    },

    {
      path: "/dailystatement",
      name: "dailystatement",
      component: DailyStatement,
    },
    {
      path: "/commissions",
      name: "commissions",
      component: Commissions,
    },
    {
      path: "/mycommissions",
      name: "mycommissions",
      component: MyCommissions,
    },
    {
      path: "/offers",
      name: "offers",
      component: Offers,
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
    },
    {
      path: "/account",
      name: "account",
      component: Account,
    },
    {
      path: "/loadmoney",
      name: "loadmoney",
      component: Loadmoney,
    },
    {
      path: "/qrcode",
      name: "qrcode",
      component: QRcode,
    },
    {
      path: "/withdrawaltobank",
      name: "withdrawaltobank",
      component: WithdrawaltoBank,
    },
    {
      path: "/dthbooking",
      name: "dthbooking",
      component: DTHBooking,
    },
    {
      path: "/dailyuserreport",
      name: "dailyuserreport",
      component: DailyUserReport,
    },
    {
      path: "/complaint",
      name: "complaint",
      component: Complaint,
    },
    {
      path: "/shopping",
      name: "shopping",
      component: Shopping,
    },
    {
      path: "/instantPayout",
      name: "instantPayout",
      component: InstantPayout,
    },
    {
      path: "/aepsPayout",
      name: "aepsPayout",
      component: AEPSPayout,
    },
    {
      path: "/paytmcallback",
      name: "paytmcallback",
      component: PaytmCallback,
    },
    {
      path: "/getqrcode",
      name: "getqrcode",
      component: GetQRCode,
    },
    
  ],
});
